import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Heading/Heading.tsx
import { forwardRef, useMemo } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "h1";
var HEADING_CLASSNAME_MAP = {
  variant: {
    primary: "",
    display: "pd:heading--display"
  },
  size: {
    "1": "pd:heading--1",
    "2": "pd:heading--2",
    "3": "pd:heading--3",
    "4": "pd:heading--4"
  }
};
var Heading = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "primary",
      size: sizeProp,
      className = ""
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "size", "className"]);
  const Component = as != null ? as : DEFAULT_COMPONENT;
  const size = useMemo(() => {
    if (!sizeProp) {
      switch (Component) {
        case "h1":
          return "1";
        case "h2":
          return "2";
        case "h3":
          return "3";
        case "h4":
          return "4";
        default:
          return "4";
      }
    }
    return sizeProp;
  }, [Component, sizeProp]);
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:heading", HEADING_CLASSNAME_MAP.variant[variant], size && HEADING_CLASSNAME_MAP.size[size], className)
  }, rest), {
    children
  }));
});
var StoryHeading = properties => /* @__PURE__ */jsx(Heading, __spreadValues({}, properties));
var Heading_default = Heading;
export { HEADING_CLASSNAME_MAP, StoryHeading, Heading_default };